import { VALUE_TYPES } from "@/static/valueTypes";
import { AttributeTemplate } from "@/models/api/administration/servicesAndAttributes/AttributeTemplate";

export class AttributeTemplateAddEdit {
  name!: string;
  attributeCode!: string;
  attributePrototypeId!: number | null;
  description!: string | null;
  valueType!: VALUE_TYPES;
  defaultValue!: string;
  isRequired!: boolean;
  isPrintable!: boolean;
  attributeSource!: string | null;

  constructor() {
    this.name = "";
    this.attributeCode = "";
    this.attributePrototypeId = null;
    this.description = "";
    this.valueType = VALUE_TYPES.Unknown;
    this.defaultValue = "";
    this.isRequired = false;
    this.isPrintable = false;
    this.attributeSource = "";
  }

  static fromAttributeTemplate(attributeTemplate: AttributeTemplate): AttributeTemplateAddEdit {
    const attributeTemplateAddEdit = new AttributeTemplateAddEdit();
    attributeTemplateAddEdit.name = attributeTemplate.name;
    attributeTemplateAddEdit.attributeCode = attributeTemplate.attributeCode;
    attributeTemplateAddEdit.attributePrototypeId = attributeTemplate.attributePrototypeId;
    attributeTemplateAddEdit.description = attributeTemplate.description;
    attributeTemplateAddEdit.valueType = attributeTemplate.valueType;
    attributeTemplateAddEdit.defaultValue = attributeTemplate.defaultValue;
    attributeTemplateAddEdit.isRequired = attributeTemplate.isRequired;
    attributeTemplateAddEdit.isPrintable = attributeTemplate.isPrintable;
    attributeTemplateAddEdit.attributeSource = attributeTemplate.attributeSource;
    return attributeTemplateAddEdit;
  }
}
